import { Attribute as h } from "./Attribute.js";
class p {
  attributes;
  nameToAttribute;
  constructor() {
    this.attributes = [], this.nameToAttribute = {};
  }
  addWithAll(i, e, t, a) {
    const r = new h(i, e, t, a);
    return this.attributes.push(r), this.nameToAttribute[i] = r, r;
  }
  addInherited(i, e) {
    return this.addWithAll(i, e, void 0, !1);
  }
  add(i, e, t) {
    return this.addWithAll(i, void 0, e, t);
  }
  getAttributes() {
    return this.attributes;
  }
  getModelName(i) {
    const e = this.nameToAttribute[i];
    if (e !== void 0)
      return e.modelName;
  }
  toJson(i, e) {
    for (const t of this.attributes) {
      const a = e[t.name];
      (t.alwaysWriteJson || a !== t.defaultValue) && (i[t.name] = a);
    }
  }
  fromJson(i, e) {
    for (const t of this.attributes) {
      const a = i[t.name];
      a === void 0 ? e[t.name] = t.defaultValue : e[t.name] = a;
    }
  }
  update(i, e) {
    for (const t of this.attributes)
      if (i.hasOwnProperty(t.name)) {
        const a = i[t.name];
        a === void 0 ? delete e[t.name] : e[t.name] = a;
      }
  }
  setDefaults(i) {
    for (const e of this.attributes)
      i[e.name] = e.defaultValue;
  }
  toTypescriptInterface(i, e) {
    const t = [], a = this.attributes.sort((r, s) => r.name.localeCompare(s.name));
    t.push("export interface I" + i + "Attributes {");
    for (let r = 0; r < a.length; r++) {
      const s = a[r];
      let l = s.type, n, o = s, u;
      o.defaultValue !== void 0 ? n = o.defaultValue : o.modelName !== void 0 && e !== void 0 && e.nameToAttribute[o.modelName] !== void 0 && (u = o.modelName, o = e.nameToAttribute[o.modelName], n = o.defaultValue, l = o.type);
      const d = JSON.stringify(n), m = o.required || o.fixed ? "" : "?";
      if (s.fixed)
        t.push("	" + s.name + ": " + d + ";");
      else {
        const f = (n !== void 0 ? "default: " + d : "") + (u !== void 0 ? " - inherited from global " + u : "");
        t.push(
          "	" + s.name + m + ": " + l + ";" + (f.length > 0 ? " // " + f : "")
        );
      }
    }
    return t.push("}"), t.join(`
`);
  }
}
export {
  p as AttributeDefinitions
};
//# sourceMappingURL=AttributeDefinitions.js.map
